module.exports = __webpack_public_path__ + "img/over-speeding_map.d1e33578.svg";